/*!
 *
 * Copyright 2019 Dmitry Chuba
 */

jQuery(function ($) {
    'use strict';
    $('#podcastPopup')
        .on('show.bs.modal', function (event) {
            const url   = $(event.relatedTarget).data('href');
            const title = $(event.relatedTarget).data('title');

            $(this).find('.modal-content iframe').attr('src', url);
            $(this).find('.modal-title').html(title);
        })
        .on('hide.bs.modal', function () {
            $(this).find('.modal-content iframe').attr('src', '');
            $(this).find('.modal-title').html('');
        });

});
